import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { formatDate } from "../../lib/dateUtils";

const STATUS_LABEL = {
  registered: "Waiting to be matched",
  matched: "Matched",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const RegistrationsTab = () => {
  const [bookings, setBookings] = useState(null);

  useEffect(() => {
    api.get("/admin/bookings").then(({ data }) => setBookings(data));
  }, []);

  if (bookings === null) return <p className="font-medium text-midnight-black/60">Loading registrations...</p>;
  if (bookings.length === 0) return <p className="font-medium text-midnight-black/60" data-testid="no-admin-bookings">No registrations yet.</p>;

  return (
    <div className="space-y-3" data-testid="admin-bookings-list">
      {bookings.map((b) => (
        <div key={b.id} className="border border-soft-gray rounded-xl p-4 flex items-center justify-between gap-4 flex-wrap" data-testid={`admin-booking-row-${b.id}`}>
          <div>
            <p className="font-extrabold text-sm uppercase">{b.stranger_name || "Unknown Stranger"}</p>
            <p className="text-xs font-medium text-midnight-black/60">{b.stranger_email}</p>
            <p className="text-xs font-medium text-midnight-black/50">
              {b.session_title} · {b.session_city} · {formatDate(b.session_date)}
            </p>
          </div>
          <span className="text-[10px] font-bold tracking-widest uppercase bg-soft-gray px-3 py-1 rounded-full">{STATUS_LABEL[b.status] || b.status}</span>
        </div>
      ))}
    </div>
  );
};
